export default __webpack_public_path__ + "static/media/oauth.b31bfc53.png";